export default {
    phoneEncryption(number){
	    let str = String(number);
	    return str.substr(0,3) + '****' + str.substr(7,10)
	},
	Subtr(arg1,arg2){
		let r1,r2,m,n;
		try{r1=arg1.toString().split(".")[1].length}catch(e){r1=0}
		try{r2=arg2.toString().split(".")[1].length}catch(e){r2=0}
		m=Math.pow(10,Math.max(r1,r2));
		//last modify by deeka
		//动态控制精度长度
		n=(r1>=r2)?r1:r2;
		return ((arg1*m+arg2*m)/m).toFixed(n);
	},
	accMul(arg1,arg2){
		var m=0,s1=arg1.toString(),
		s2=arg2.toString();  
		try{
			m+=s1.split(".")[1].length}catch(e){}  
		try{
			m+=s2.split(".")[1].length}catch(e){}  
		return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m)
	},

	getImageFormat(base64String) {
		return base64String.split(',')[0].match(/jpeg|png/i) ? '.'+base64String.split(',')[0].match(/jpeg|png/i)[0] : null;
	},
	
	splitMinutes(m) {
		var day = parseInt(m / 1440);
		var hour = parseInt((m % 1440) / 60);
		var minu = (m % 1440) % 60;
		return (
			(day ? day + "天" : "") +
			(hour ? hour + "小时" : "") +
			(minu || 0) +
			"分钟"
		);
	},
	
	/**
	 * 将时间戳转换为指定格式的日期字符串
	 * @param {number|string} timestamp - 时间戳（支持秒或毫秒）
	 * @param {string} [format='YYYY-MM-DD HH:mm:ss'] - 日期格式，例如 'YYYY-MM-DD'、'YYYY/MM/DD HH:mm:ss'
	 * @returns {string} 格式化后的日期字符串
	 */
	formatDate(timestamp, format = 'YYYY-MM-DD HH:mm:ss') {
	  if (!timestamp) return '';
	
	  // 处理时间戳：如果是10位数字（秒），则转为毫秒；否则视为毫秒
	  const ts = String(timestamp).length === 10 ? timestamp * 1000 : timestamp;
	  const date = new Date(ts);
	
	  // 检查日期是否有效
	  if (isNaN(date.getTime())) {
	    console.warn('Invalid timestamp:', timestamp);
	    return '';
	  }
	
	  const pad = (n) => (n < 10 ? '0' + n : n);
	
	  const year = date.getFullYear();
	  const month = pad(date.getMonth() + 1);
	  const day = pad(date.getDate());
	  const hours = pad(date.getHours());
	  const minutes = pad(date.getMinutes());
	  const seconds = pad(date.getSeconds());
	
	  // 替换格式字符串中的占位符
	  return format
	    .replace('YYYY', year)
	    .replace('MM', month)
	    .replace('DD', day)
	    .replace('HH', hours)
	    .replace('mm', minutes)
	    .replace('ss', seconds);
	}

    
}